<template>
    <div>
        <h1>{{ integration.name }} Setup</h1>

        <h2>Benötigte Werte eintragen</h2>
        <span>Tragen Sie bitte die benötigten Werte in die Felder ein.</span>

        <div v-for="layer in layers">
            <div v-if="fields.hasOwnProperty(layer) && fields[layer].length > 0" class="mt-5">
                <h3>{{ layer }}-Ebene</h3>
                <div class="row">
                    <div class="col-4" v-for="(entry) in fields[layer]">
                        <div class="form-group">
                            <label class="font-weight-bold" v-text="entry.field"/>
                            <input class="form-control" type="text" :placeholder="entry.field">
                            <span class="form-text text-muted" v-text="entry.description"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <button class="btn btn-primary">Weiter</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        integration: Object,
        fields: Object,
    },

    data() {
        return {
            layers: ['user', 'store'],
        }
    },
}
</script>
